import React from 'react';
import autoBind from 'react-autobind';
import { Form, Row, Col, Input, Button, Popover, Divider, Modal, message } from 'antd';
//
import config from '../../../config/config';
import Utils from '../../../components/Utils';
import { InfoCircleOutlined, LinkOutlined, EditOutlined } from '@ant-design/icons';
//
export default class CommonDetailsLicensesForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      licenseOwner: '',
      assignedFrom: '',
      product: [],
      showEditAssignmentsModal: false,
      newAssignCount: null,
      loading: false,
    };
  }
  //Public
  resetFields() {
    this.form.resetFields();
  }
  setFieldsValue(data) {
    this.form.setFieldsValue({ ...data });
  }
  async validateFields() {
    const formData = await this.form.validateFields();
    if (!formData) return false;
    return formData;
  }
  //Fetch license owner when the component mounts
  async componentDidMount() {
    await this._fetchLicenseOwner();
    await this._fetchAssignedOwer();
    await this._fetchProduct();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.licenses !== this.props.licenses) {
      this.setFieldsValue(this.props.licenses);
      this._fetchLicenseOwner();
      this._fetchAssignedOwer();
      this._fetchProduct();
    }
  }

  //UI
  render() {
    const emails = Array.isArray(this.props.licenses?.order?.email)
      ? this.props.licenses.order.email.join(', ')
      : ' ';
    const isAssignment = this.props.licenses?.isAssignment;
    const completedOn = Utils.getDateAndTimeOnUIFormatByTimestamp(this.props.licenses?.order?.completedOn);
    const { licenseOwner } = this.state;
    const redirectToOwnerPage = this.props.app.urlManager.parseUrl(
      config.ApplicationRoutes.editOrg,
      null,
      this.props.licenses?.assignedFromOwnerID
    );
    const redirectToKey = this.props.app.urlManager.parseUrl(
      config.ApplicationRoutes.adminLicensesView,
      null,
      this.props.licenses?.origActivationKey
    );
    return (
      <>
        {this.renderEditAssignmentsModal()}
        <Form {...Utils.propagateRef(this, 'form')}>
          <span style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 4 }}>
            Activation key information
          </span>
          <Divider style={{ marginTop: 4, marginBottom: 12 }} />
          <Row type="flex" justify="center">
            <Col span={12}>
              <Form.Item label="Key" name="id">
                {this.props.licenses?.id}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Key Status" name="state">
                {this.props.licenses?.state}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="License ID" name="licenseID">
                {this.props.licenses?.licenseID}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Product" name={['order', 'productName']}>
                {this.props.licenses?.order?.productName}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Order" name={['license', 'orderID']}>
                {this.props.licenses?.license?.orderID}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Order Status" name={['order', 'status']}>
                {this.props.licenses?.order?.status}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Completed">{completedOn}</Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <Popover content={emails} title="Emails">
                    Purchaser <InfoCircleOutlined style={{ marginLeft: '4px' }} />
                  </Popover>
                }
                name={['order', 'name']}
              >
                {this.props.licenses?.order?.name}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="License Owner">{licenseOwner}</Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Activations" name="numActivations">
                {this.props.licenses?.numActivations}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Max Activations" name="maxActivations">
                {this.props.licenses?.maxActivations}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Reservations" name="reservedCount">
                {this.props.licenses?.reservedCount}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Assignments" name="assignCount">
                {this.props.licenses?.assignCount}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Assign Activ" name="assignActivations">
                {this.props.licenses?.assignActivations}
              </Form.Item>
            </Col>

            {isAssignment && (
              <>
                <Col span={12}>
                  <span style={{ color: '#af3947' }}>Assigned License</span>
                </Col>
                <Col span={6}>
                  <Form.Item label="By:" name="assignedFromOwnerID">
                    <Button
                      type="link"
                      href={redirectToOwnerPage}
                      target="_blank"
                      rel="noopener noreferrer"
                      icon={<LinkOutlined />}
                    >
                      {this.state.assignedFrom || ' '}
                    </Button>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label="Key:" name="id">
                    <Button
                      type="link"
                      href={redirectToKey}
                      target="_blank"
                      rel="noopener noreferrer"
                      icon={<LinkOutlined />}
                    >
                      {this.props.licenses?.origActivationKey || ' '}
                    </Button>
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <span style={{ fontSize: '14px', fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
            License Information
          </span>

          <Divider style={{ marginTop: 4, marginBottom: 12 }} />

          {this.state.product?.generateIndividualKeys && (
            <div style={{ color: '#af3947', marginBottom: 8 }}>
              <strong>Attention:</strong> Be careful when updating info. This is a multi key license and the information below includes numbers from other keys.
            </div>
          )}

          <Row type="flex" justify="center">
            <Col span={12}>
              <Form.Item label="Activations" name="licActivated">
                {this.props.licenses?.license?.licActivated ?? ' '}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Max Activations" name="licNumber">
                {this.props.licenses?.license?.licNumber ?? ' '}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Reservations" name="reservedCount">
                {this.props.licenses?.license?.reservedCount ?? ' '}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={
                  <span>
                    Assignments{' '}
                    <Button type="link" icon={<EditOutlined />} onClick={this.handleEditAssignments} disabled={!this.props.licenses?.license}></Button>
                  </span>
                }
                name="assignCount"
              >
                {this.props.licenses?.license?.assignCount ?? ' '}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Assign Activ" name="assignActivations">
                {this.props.licenses?.license?.assignActivations ?? ' '}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </>
    );
  }

  //Private UI
  renderEditAssignmentsModal() {
    const { showEditAssignmentsModal, newAssignCount, loading } = this.state;

    const showConfirmModal = () => {
      Modal.confirm({
        title: "Are you sure?",
        content: (
          <div>
            This operation will overwrite the number of assignments of the license.
            <br />
            <strong>This operation cannot be reversed or traced</strong>, make sure the license is not being used before you continue.
          </div>
        ),
        okText: "Confirm",
        cancelText: "Cancel",
        onOk: this.handleConfirmAssignments,
      });
    };

    return (
      <Modal
        title="Edit Assignment Count"
        open={showEditAssignmentsModal}
        onCancel={() => this.setState({ showEditAssignmentsModal: false })}
        footer={[
          <Button key="cancel" onClick={() => this.setState({ showEditAssignmentsModal: false })}>
            Cancel
          </Button>,
          <Button
            key="ok"
            type="primary"
            disabled={newAssignCount < 0 || isNaN(newAssignCount)}
            onClick={showConfirmModal}
          >
            OK
          </Button>,
        ]}
      >
        <Form layout="vertical">
          <Form.Item
            label="New Assignment Count"
            required
            validateStatus={newAssignCount < 0 ? "error" : undefined}
            help={newAssignCount < 0 ? "Must be zero or greater." : undefined}
          >
            <Input
              type="number"
              style={{ width: 360 }}
              min={0}
              value={newAssignCount}
              onChange={(e) => this.setState({ newAssignCount: parseInt(e.target.value || "0", 10) })}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  // Private methods
  handleEditAssignments() {
    const current = this.props.licenses?.license?.assignCount ?? 0;
    this.setState({ showEditAssignmentsModal: true, newAssignCount: current, });
  }
  async handleConfirmAssignments() {
    const { newAssignCount } = this.state;
    const externalID = this.props.licenses?.externalID;
    const licenseID = this.props.licenses?.licenseID;

    this.setState({ loading: true });
    const resp = await this.props.app.license.license.assignLicenseCount(externalID, licenseID, { assignments: newAssignCount });
    if (resp.statusCode === 200) {
      message.success('Assignments updated.');
      this.setState({ showEditAssignmentsModal: false });
      this.props.onReload?.(); // Trigger refresh
    } else {
      message.error('Failed to update assignments.');
      this.setState({ showEditAssignmentsModal: false });
    }
  }
  async _fetchLicenseOwner() {
    const licenses = this.props.licenses;
    let licenseOwner = ' ';

    if (!licenses?.externalID) return;
    if (licenses.isAssignment) {
      const idmResp = await this.props.app.idm.api.user.read(licenses?.externalID);
      licenseOwner = `${idmResp.body.firstName} ${idmResp.body.lastName}`;
    } else {
      const orgResp = await this.props.app.organization.organizationApp.getOrganizationApp(licenses?.externalID);
      if (orgResp.statusCode == 200 && orgResp.body) {
        licenseOwner = orgResp.body.name;
      }
    }
    this.setState({ licenseOwner });
  }
  async _fetchAssignedOwer() {
    const assignedFromOwnerID = this.props.licenses?.assignedFromOwnerID;
    let assignedFrom = ' ';
    if (!assignedFromOwnerID) return;
    const orgResp = await this.props.app.organization.organizationApp.getOrganizationApp(assignedFromOwnerID);
    if (orgResp.statusCode == 200 && orgResp.body) {
      assignedFrom = orgResp.body.name;
    }
    this.setState({ assignedFrom });
  }
  async _fetchProduct() {
    const product = await this.props.app.sharedCache().getProductByID(this.props.licenses?.productID);
    console.log('product', product);
    if (product) {
      this.setState({ product });
    }
  }
}
